// jshint esversion: 6
(function($) {
    // vars
    let apiLoaded = ( 'object' === typeof google && 'object' === typeof google.maps );
    let acfMaps = document.querySelectorAll( '.acf-map' );
    let googleMaps = [];
    let customMapStyles = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
];
    let customMapMarker = {
        path: "M1268.00011,1591 C1258.63128,1591 1251,1598.658 1251,1608.05962 C1251,1616.05374 1263.28568,1631.20027 1266.98968,1635.53485 C1267.55072,1636.15505 1268.50404,1636.15505 1269.01032,1635.53485 C1272.65709,1631.20015 1285,1616.11116 1285,1608.05962 C1285,1598.60057 1277.36872,1591 1267.99989,1591 L1268.00011,1591 Z M1273.78764,1616.37789 C1264.03179,1621.99967 1254.00033,1611.96821 1259.62211,1602.21236 C1260.22932,1601.10994 1261.16594,1600.22712 1262.21236,1599.62211 C1271.96821,1594.00033 1281.99967,1604.03179 1276.37789,1613.78764 C1275.77282,1614.83406 1274.83406,1615.77288 1273.78764,1616.37789 Z",
        fillColor: '#000' // MARKER COLOR
    };

    // Create info window outside of each - then tell that singular infowindow to swap content based on click
    if ( apiLoaded ) {
        let infowindow = new google.maps.InfoWindow({
            content: ''
        });
    }

    // Renders a Google Map onto the selected jQuery element
    function new_map( $el ) {

        // all map markers
        let $markers = $el.find( '.marker' );

        // map args
        let args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        // Custom map styles used if .acf-map has .custom-styles class
        let useCustomStyles = $el.hasClass( 'custom-styles' );

        // create map
        let map = new google.maps.Map( $el[0], args );

        // add a markers reference
        map.markers = [];

        // map options
        map.setOptions({
            styles: useCustomStyles ? customMapStyles : null,
            scrollwheel: false
        });

        // add markers to map
        for ( let i = 0; i < $markers.length; i++ ) {
            add_marker( $($markers[i]), map, useCustomStyles );
        }

        // center map on page load
        center_map( map );

        // return
        return map;
    }

    // Adds a marker to the selected Google Map
    function add_marker( $marker, map, useCustomMarker = false ) {

        // marker lat/lng
        let lat = $marker.attr('data-lat');
        let lng = $marker.attr('data-lng');
        let latlng = new google.maps.LatLng( lat, lng );

        // Detect Host
        let hostURL = '';
        if ( window.location.host == 'dev1.nvdev.ca' ) {
            hostURL = 'http://dev1.nvdev.ca/trevisana';
        } else if ( window.location.host == 'localhost:3000' ) {
            hostURL = 'http://localhost:3000/trevisana';
        } else {
            hostURL = window.location.protocol + '//' + 'trevisana.wpengine.com'
        }

        // Icon 
        var icon = {
          url: `${hostURL}/wp-content/themes/trevisana/assets/img/icon-marker.svg`,
          //scaledSize: new google.maps.Size(45, 90)
        };

        // marker args
        let args = {
            icon: icon,
            position: latlng,
            map: map
            
        }

        // apply custom marker if .acf-map has .custom-styles
        if ( useCustomMarker ) {
            // args.icon = {
            //     path: customMapMarker.path,
            //     scale: 0.65,
            //     fillColor: customMapMarker.fillColor,
            //     fillOpacity: 1
            // }
        }

        // create marker
        let marker = new google.maps.Marker( args );

        // add to array
        map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if ( $marker.html() ) {
            // show info window when marker is clicked & close other markers
            google.maps.event.addListener(marker, 'click', function() {
                //swap content of that singular infowindow
                infowindow.setContent( $marker.html() );
                infowindow.open( map, marker );
            });

            // close info window when map is clicked
            google.maps.event.addListener(map, 'click', function( event ) {
                if ( infowindow ) {
                    infowindow.close();
                }
            });
        }
    }

    // Centers the map, showing all markers attached to this map
    function center_map( map ) {
        let bounds = new google.maps.LatLngBounds();
        let mapMarkers = map.markers;

        // loop through all markers and create bounds
        for ( let i = 0; i < mapMarkers.length; i++ ) {
            let mapMarker = mapMarkers[i];
            let lat = mapMarker.position.lat();
            let lng = mapMarker.position.lng();
            let latlng = new google.maps.LatLng( lat, lng );

            bounds.extend( latlng );
        }

        // determine map position based on marker count
        if ( mapMarkers.length == 1 ) {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
        } else {
            // fit to bounds
            map.fitBounds( bounds );
        }
    }

    // Wait until page loaded to create maps/center markers
    $(function() {
        if ( apiLoaded ) {
            // Render all maps
            if ( acfMaps.length ) {
                for ( let i = 0; i < acfMaps.length; i++ ) {
                    let map = new_map( $(acfMaps[i]) );
                    googleMaps.push( map );
                }
            }

            // Center maps on resize
            if ( googleMaps.length ) {
                google.maps.event.addDomListener(window, 'resize', function() {
                    for ( let i = 0; i < googleMaps.length; i++ ) {
                        center_map( googleMaps[i] );
                    }
                });
            }
        }
    });

})(jQuery);
